import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export const BlankIcon: React.VFC<IconProps> = ({ size, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
